/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import Banner from "../Banner/BannerComponent";
import Conteudo from "../Conteudo/ConteudoComponent";
import Footer from "../Footer/FooterComponent";
import Header from "../Header/HeaderComponent";

const Main = () => {
    return(
        <>
            <main className="main">
                <Header />
                    <Banner />
                        <Conteudo/> 
                <Footer/>                             
                            
            </main>
        </>
    )
};

export default Main